module.exports = __webpack_public_path__ + "static/media/17.8e681b4f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/17.jpg
// module id = 85
// module chunks = 0